import { Link, Typography } from '@mui/material'
import { styled } from '@mui/system'
import { LINK_SUPPORT, LINK_TERMSOFUSE } from 'config'

const FooterContainer = styled('footer')(() => ({
  position: 'absolute',
  left: 0,
  bottom: 0,
  width: '100%',
  marginTop: 'auto',
  paddingTop: '10px',
  backgroundColor: '#f7f7fc',
  color: '#939393',

  '& ul': {
    paddingLeft: '20px',
    listStyle: 'none',
    marginTop: 0,
    marginBottom: '1rem',
  },
  '& li': {
    position: 'relative',
    display: 'inline-block',
    paddingRight: '12px',
    color: 'rgb(112, 112, 114)',
  },
  '& li::after': {
    content: '""',
    position: 'absolute',
    top: '1px',
    right: 0,
    height: '12px',
    borderColor: '#dddde1',
    display: 'inline-block',
    marginRight: '3px',
    marginTop: '7px',
    width: 0,
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    verticalAlign: '-1px',
    overflow: 'hidden',
  },
  '& li:last-child:after': {
    border: 'none',
  },
  '& li a': {
    color: 'rgb(112, 112, 114)',
    fontSize: '12px',
    '&:hover': { color: '#007bff' },
  },
}))

const FooterLeft = styled('div')(() => ({
  display: 'inline-block',
  height: 0,
}))

const FooterRight = styled(Typography)(() => ({
  float: 'right',
  paddingRight: 20,
  marginBottom: '1rem',
}))

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterLeft>
        <ul>
          <li>
            <Link href={LINK_TERMSOFUSE}>利用規約</Link>
          </li>
          <li>
            <Link href={LINK_SUPPORT}>お問い合わせ</Link>
          </li>
        </ul>
      </FooterLeft>
      <FooterRight variant="caption">
        ©&nbsp;<strong>LINE WORKS Corp.</strong>
      </FooterRight>
    </FooterContainer>
  )
}

export default Footer
